var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "apps-integration-options" } },
    [
      !_vm.options.avatar
        ? _c("div", {
            staticClass: "app-avatar-default",
            style: _vm.getAvatarStyle,
            domProps: { innerHTML: _vm._s(_vm.DEFAULT_AVATAR_SVG) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.options.avatar
        ? _c("img", {
            staticClass: "app-avatar",
            attrs: { src: _vm.options.avatar },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          label: _vm.$t("HITL.common.properties.avatar"),
          placeholder: _vm.$t(
            "HITL.app-launcher.apps-integration.avatar-option-placeholder"
          ),
        },
        model: {
          value: _vm.$v.options.avatar.$model,
          callback: function ($$v) {
            _vm.$set(_vm.$v.options.avatar, "$model", $$v)
          },
          expression: "$v.options.avatar.$model",
        },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          label: _vm.$t(
            "HITL.app-launcher.apps-integration.color-option-label"
          ),
          placeholder: _vm.DEFAULT_COLOR_PLACEHOLDER,
          hint: _vm.$t("HITL.app-launcher.apps-integration.color-option-hint"),
          error: _vm.getErrorText("color"),
          required: "",
        },
        model: {
          value: _vm.$v.options.color.$model,
          callback: function ($$v) {
            _vm.$set(_vm.$v.options.color, "$model", $$v)
          },
          expression: "$v.options.color.$model",
        },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          label: _vm.$t("HITL.common.properties.name"),
          error: _vm.getErrorText("name"),
          maxlength: "255",
          required: "",
        },
        model: {
          value: _vm.$v.options.name.$model,
          callback: function ($$v) {
            _vm.$set(_vm.$v.options.name, "$model", $$v)
          },
          expression: "$v.options.name.$model",
        },
      }),
      _vm._v(" "),
      _c("or-textarea", {
        attrs: {
          label: _vm.$t("HITL.common.properties.description"),
          rows: { min: 3, max: 3 },
        },
        model: {
          value: _vm.$v.options.description.$model,
          callback: function ($$v) {
            _vm.$set(_vm.$v.options.description, "$model", $$v)
          },
          expression: "$v.options.description.$model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }